import './Carousel.css';
import { useState, useEffect, useRef } from 'react';
import cap from './assets/cap.jpg'
import jeff from './assets/jeff.jpg'
import lumb from './assets/lumb.png'
import murphy from './assets/murphy.jpg'
import stw from './assets/stw.png'
import qbs from './assets/qbs.jpg'
import fmb from './assets/fmb.png'

function Carousel() {
  const logos = [
    cap,
    jeff,
    lumb,
    murphy,
    stw,
    qbs,
    fmb

  ];

  const duplicatedLogos = [...logos, ...logos, ...logos];
  const carouselRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!isDragging && carouselRef.current) {
        carouselRef.current.scrollLeft += 2;
        if (carouselRef.current.scrollLeft >= carouselRef.current.scrollWidth / 2) {
          carouselRef.current.scrollLeft = 0;
        }
      }
    }, 50);
    return () => clearInterval(interval);
  }, [isDragging]);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - carouselRef.current.offsetLeft);
    setScrollLeft(carouselRef.current.scrollLeft);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - carouselRef.current.offsetLeft;
    const walk = (x - startX) * 3;
    carouselRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleTouchStart = (e) => {
    setIsDragging(true);
    setStartX(e.touches[0].pageX - carouselRef.current.offsetLeft);
    setScrollLeft(carouselRef.current.scrollLeft);
  };

  const handleTouchMove = (e) => {
    if (!isDragging) return;
    const x = e.touches[0].pageX - carouselRef.current.offsetLeft;
    const walk = (x - startX) * 3;
    carouselRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
  };

  return (
    <div className="carousel-section">
      <h2>We Use Industry Leading Brands for the Best Quality</h2>
      <div
        className="carousel"
        ref={carouselRef}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
        onTouchStart={handleTouchStart}
        onTouchMove={handleTouchMove}
        onTouchEnd={handleTouchEnd}
      >
        {duplicatedLogos.map((logo, index) => (
          <div key={index} className="carousel-item">
            <img src={logo} alt={`Partner ${(index % logos.length) + 1}`} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Carousel;
